import { AchievementDefinition } from '../types';

export interface AchievementNotice {
  id: string;
  achievement: AchievementDefinition;
}

interface Props {
  notices: AchievementNotice[];
  onDismiss: (id: string) => void;
}

export function AchievementToastContainer({ notices, onDismiss }: Props) {
  if (!notices.length) return null;
  return (
    <div className="achievement-toast-container" aria-live="polite">
      {notices.map((notice) => (
        <div key={notice.id} className="achievement-toast" role="status">
          <div className="achievement-toast-header">
            <div>
              <p className="eyebrow">Achievement unlocked</p>
              <strong>{notice.achievement.name}</strong>
            </div>
            <button className="btn ghost" onClick={() => onDismiss(notice.id)} aria-label="Dismiss achievement">
              ×
            </button>
          </div>
          <p className="helper-text">{notice.achievement.description}</p>
        </div>
      ))}
    </div>
  );
}
